/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ShowManagementCreateShowResponse } from './ShowManagementCreateShowResponse';

export type ShowManagementCreateShowResponseApiRespoonse = {
    data?: ShowManagementCreateShowResponse;
    status?: ShowManagementCreateShowResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ShowManagementCreateShowResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

